module.exports = __webpack_public_path__ + "images/pages/lp/bulk_estimate_guide_2_6e72f74b908cbe7dfe26c97cd45ced3a.png";